import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { useRecoilValue } from "recoil"
import { fhAnalyticsUserActions } from "../../../../common/constants/constants"
import { tabs } from "../../../../common/constants/search-constants"
import sendFhAnalytics from "../../../../common/lib/fredhopper"
import { countryIdState, searchServiceLocaleState } from "../../../../common/store/settingsStore"
import { FhResponseData } from "../../../../common/types/search"
import { createPartials } from "../../../../common/utils/search-utils"
import PartialResultsView from "../PartialResultsView/PartialResultsView"

type Props = {
  queryAlternatives: FhResponseData
  searchTerm: string
}

const PartialResultsContainer = ({ queryAlternatives, searchTerm }: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const [partials, setPartials] = useState([])
  const countryId = useRecoilValue(countryIdState)
  const searchServiceLocale = useRecoilValue(searchServiceLocaleState)

  const { locale, query } = useRouter()
  const brand = query?.brand as string

  // TODO (nan): Reuse this part for new ErrorModal implementation
  // const hasError = !!error;

  useEffect(() => {
    if (!queryAlternatives || error) return

    setIsLoading(true)

    const querySuggestions = queryAlternatives.query_suggestion

    createPartials({ querySuggestions, searchTerm, searchServiceLocale, countryId, brand })
      .then((res) => {
        //Sort alternative suggestion results by number of expected results
        const sortedPartials = res.sort((a: FhResponseData, b: FhResponseData) => b.numberOfResults - a.numberOfResults)
        setPartials(sortedPartials)

        sortedPartials.forEach(({ rid }) => {
          //track pageview analytics event on every FH request for products & spt
          sendFhAnalytics({ locale, query, action: fhAnalyticsUserActions.PARTIALS_PAGEVIEW, sourceId: rid[tabs.PRO] })
          sendFhAnalytics({ locale, query, action: fhAnalyticsUserActions.PARTIALS_PAGEVIEW, sourceId: rid[tabs.SPT] })
        })
      })
      .catch((err) => {
        console.log("CREATE PARTIALS ERROR: ", err)
        setError(err)
      })
      .finally(() => setIsLoading(false))
  }, [error])

  // TODO (nan): Reuse this part for new ErrorModal implementation
  // const resetError = () => {
  //   setError(null);
  // };

  return (
    <>
      {/* TODO (nan) ErroModal needs to be reimplemeneted, maybe with ErrorBoundary? */}
      {/* {hasError && <ErrorModal hasError={hasError} resetError={resetError} />} */}
      <PartialResultsView isLoading={isLoading} partials={partials} />
    </>
  )
}

export default PartialResultsContainer
